import { SourceType } from '@/modules/surgicalEvent';
import { themeColors } from '@ianesthesie-kit/config';
import { Box, BoxProps, css } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { cloneElement, ReactElement, Children } from 'react';
import { SourceTypeBadge } from './badge/SourceTypeBadge';
import { getSourceTypeThemeColor, isDisplayable } from './util';

const Wrapper = styled(Box, {
  shouldForwardProp: (p) =>
    p !== 'sourceType' && p !== 'styleBorder' && p !== 'baseZIndex'
})<{ sourceType?: SourceType; styleBorder: boolean; baseZIndex: number }>`
  position: relative;
  display: flex;

  ${(props) =>
    isDisplayable(props.sourceType) &&
    css`
      .content {
        &::after {
          content: '';
          width: 12px;
          height: 12px;
          background: inherit;
          position: absolute;
          z-index: ${props.baseZIndex};
          border-radius: 0;
          left: 0;
          top: 0;
        }

        ${props.styleBorder &&
        css`
          border-width: 1px;
          border-style: dashed;
          border-color: ${themeColors[
            getSourceTypeThemeColor(props.sourceType)
          ][500]};
        `}
      }
      .source-type-icon {
        z-index: ${props.baseZIndex + 1};
        svg {
          position: absolute;
          opacity: 0.8;
          top: -8px;
          left: -8px;
          width: 16px;
          height: 16px;
          color: ${themeColors[getSourceTypeThemeColor(props.sourceType)][500]};
        }

        &.epic {
          svg {
            fill: ${themeColors[
              getSourceTypeThemeColor(props.sourceType)
            ][500]};
            color: transparent;
          }
        }
      }
    `}
`;

export type SourceTypeWrapperProps = Omit<BoxProps, 'children'> & {
  children: ReactElement;
  sourceType: SourceType | undefined;
  justification?: string;
  styleBorder?: boolean;
  baseZIndex?: number;
};

export const SourceTypeWrapper = ({
  sourceType,
  justification,
  styleBorder = true,
  children,
  baseZIndex = 9,
  ...boxProps
}: SourceTypeWrapperProps) => (
  <Wrapper
    sourceType={sourceType}
    styleBorder={styleBorder}
    baseZIndex={baseZIndex}
    {...boxProps}
  >
    <SourceTypeBadge sourceType={sourceType} justification={justification} />
    {cloneElement(Children.only(children), {
      className: 'content'
    } as any)}
  </Wrapper>
);
